<!-- Copyright: Seán I. O'Donoghue -->

<template>
  <header :class="{isScrolled}">
    <span v-if="hasLeftContent" class="leftHeader">
      <slot name="left">{{ leftHeader }}</slot>
    </span>
    <span class="headerTitle">
      <slot />
    </span>
    <AppCloseButton v-if="hasCloseButton" class="close" :on-close />
  </header>
</template>

<script setup>
import {computed, inject, ref, useSlots} from "vue";
import AppCloseButton from "@/components/App/CloseButton";

const props = defineProps({
  leftHeader: {type: String, default: ""},
  noCloseButton: {default: false},
  onClose: {type: Function, default: null},
});

const slots = useSlots();
const isScrolled = inject("isScrolled", ref(false));

const hasCloseButton = computed(() => !props.noCloseButton);
const hasLeftContent = computed(() => {
  if (typeof slots.left === "function") return true;
  return Boolean(String(props.leftHeader || "").trim());
});
</script>

<style scoped>
header {
  position: sticky;
  top: 0;
  z-index: 100;
  display: flex;
  align-items: center;
  background-color: var(--dialog-background, #e4e4e4); /* the card's (index.vue) */
  border-bottom: 2px solid transparent;
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
  gap: 0.35rem;
  transition: border-bottom-color 0.2s ease;
}
header.isScrolled {
  border-bottom-color: rgba(0, 0, 0, 0.15);
}
.leftHeader {
  flex: 0 0 auto;
  display: inline-flex;
  align-items: center;
  white-space: nowrap;
}
.headerTitle {
  flex: 1 1 auto;
  min-width: 0;
  display: flex;
  justify-content: center;
}
.headerTitle:empty {
  display: none;
}
.close {
  flex: 0 0 auto;
  margin-left: auto;
  /* ▶ EDIT HERE (2026-10-14): a circle round the drawn cross (CloseButton.vue), the familiar
     close button, so its focus ring (keyboard only) is a circle centred on it. The margins keep
     the old 40px slot (the header's height) and put the cross where the ✕ character's ink was:
     level with the tabs, its right edge on the content's */
  width: 28px;
  height: 28px;
  border-radius: 50%;
  justify-content: center;
  margin: 4.5px -3.25px 7.5px auto;
  /* drawn lower, the header's height unchanged (the heading below stays put): the cross as far
     from the card's top as from its right (Seán, 2026-10-23): 13.5px down at no offset, its ink
     1.8px in from the side padding's edge */
  position: relative;
  top: calc(var(--dialog-padding-x, 24px) - 11.7px);
}

</style>
